import { ArrowLeft, ExternalLink, X } from "lucide-react";
import { Button } from "../Button";
import React from "react";

interface HeaderProps {
    type?: 'back' | 'close' | 'none' | null | undefined;
    link?: React.ReactNode;
    onClick?: () => void;
    text?: string;
    header?: string;
};

const Heading = ({ type = 'back', link, onClick, text, header }: HeaderProps) => {
    return (
        <div className="w-full border-b border-gray-200 !p-4 gap-[6px] flex flex-col">
            <div className="flex flex-row gap-[10px] items-center">
                {
                    type === 'back' && (
                        <Button size='icon' className="size-8 flex-shrink-0" variant='outline' onClick={onClick}>
                            <ArrowLeft />
                        </Button>
                    )
                }
                <p className="overflow-hidden w-full text-ellipsis text-gray-900 font-medium text-sm leading-5 tracking-normal font-sans">
                    {header || ''}
                </p>

                {
                    type === 'close' && (
                        <Button size='icon' className="size-8 flex-shrink-0" variant='ghost' onClick={onClick}>
                            <X />
                        </Button>
                    )
                }
            </div>

            {
                text && <div className="flex flex-col gap-[6px]">
                    {
                        text && <p className="overflow-hidden text-[#887992] text-ellipsis font-sans text-sm not-italic font-normal leading-5 tracking-normal">{text}</p>
                    }

                    {
                        link && <p className="text-indigo-600 cursor-pointer font-normal text-sm leading-5 tracking-normal font-sans [&_*]:cursor-pointer [&_*]:text-inherit [&_*]:font-inherit [&_*]:leading-inherit [&_*]:tracking-inherit [&_*]:font-sans flex flex-row gap-[1px] items-center">{link} <ExternalLink size={14} /></p>
                    }
                </div>
            }
        </div>
    )
};

export default Heading;